/** Group one creature hit's like damage types before mitigation rounds down.
 * SRD 5.1 Damage Resistance and Vulnerability; date_of_change: 2026-09-05.
 * Sub-rolls remain available for the audit; this function never rolls dice.
 */
export function groupCreatureDamageDetails(details: any[]): any[] {
  const groups = new Map<string, any>();
  for (const detail of details) {
    const key = detail.damageType;
    const existing = groups.get(key);
    if (!existing) {
      groups.set(key, { ...detail, components: [{ ...detail }] });
    } else {
      existing.total += detail.total;
      existing.formula += ` + ${detail.formula}`;
      existing.rolls = [...(existing.rolls || []), ...(detail.rolls || [])];
      existing.baseRolls = [...(existing.baseRolls || []), ...(detail.baseRolls || [])];
      existing.criticalRolls = [...(existing.criticalRolls || []), ...(detail.criticalRolls || [])];
      existing.components.push({ ...detail });
    }
  }
  return [...groups.values()];
}
